/** @format */

import { takeLatest } from "redux-saga/effects";
import { TActionType } from "../declarations/actionTypes";
import { sagaPermissionList } from "../sagas/sagaPermissions";

export function* watcherPermissions(): unknown {
  yield takeLatest(TActionType.permissionListRequest, sagaPermissionList);
}
